import * as React from "react";
import styled from 'styled-components';
import { Seo } from "../../components/seo";
import Layout from "../../components/layout";
import PricingHero from "../../components/pricing/pages-component/hero";
import PricingHome from "../../components/pricing";
import FaqPricing from "../../components/pricing/pages-component/faq";
import CreateFreeAccount from "../../components/create-free-account";

const StyledHome = styled("div")`
  background-image: linear-gradient(
    to right,
    #f6ece0,
    #f5eee4,
    #f4f0e7,
    #f4f1eb,
    #f4f3ef,
    #f7f4f2,
    #f8f5f5,
    #f8f7f7,
    #faf9f9,
    #fbfbfb,
    #fdfdfd,
    #ffffff
  );
  background-size: 100% 100%;
`

const PricingPage = () => {
    return (
        <Layout>
            <StyledHome>
                <PricingHero />
                <PricingHome />
                <section className="py-5 Faq-section">
                    <FaqPricing />
                </section>
                <section className="py-5 create-free-account-section">
                    <CreateFreeAccount />
                </section>
            </StyledHome>
        </Layout>
    );
}

export default PricingPage;

export const Head = () => (
    <Seo 
        title="Pricing | Clearout"
        description="Flexible & transparent pricing. Pay-as-you-go or monthly/annual subscription. Designed for enterprises, small teams and everyone in between."
        keywords="Clearout pricing"
    />
);
